import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  books: [],
  loading: false,
  fetchedBookIds: [],
  error: null,
  status: "idle",
};

const BookSlice = createSlice({
  name: "book",
  initialState,
  reducers: {
    fetchBooksRequest: (state) => {
      state.loading = true;
      state.status = "fetching";
    },
    fetchBooksSuccess: (state, action) => {
      state.books = action.payload;
      state.loading = false;
      state.status = "success";
    },
    fetchBooksFailure: (state, action) => {
      state.error = action.payload;
      state.status = "error";
      state.loading = false;
    },
    setFetchedBookIds: (state, action) => {
      // Combine existing IDs with new IDs, remove duplicates using a Set
      // but convert back to array immediately for Redux serialization
      const uniqueIds = Array.from(
        new Set([...state.fetchedBookIds, ...action.payload])
      );
      state.fetchedBookIds = uniqueIds;
    },
  },
});
export const {
  fetchBooksRequest,
  fetchBooksSuccess,
  fetchBooksFailure,
  setFetchedBookIds,
} = BookSlice.actions;

export default BookSlice.reducer;
